import Settings from './Settings';
import SettingsToggle from './SettingsToggle';

export {
  Settings,
  SettingsToggle,
};

export default null;



// WEBPACK FOOTER //
// ./src/presentation/components/settings/index.js